<template>
	<div id="enquiry-form-widget">
		<h1 class="page-header col-12">
			{{ widgetConfig.formHeading}}&nbsp;
			<p class="btn btn-success pull-right" id="swimmanager-please-wait-button"  style="display: none"><span class="glyphicon glyphicon-refresh"></span> Sending mail</p>
			<button class="btn btn-primary pull-right" id="swimmanager-submit-button"
					@click.prevent="onSubmit"
					type="submit">Send Enquiry</button>
		</h1>
		<form novalidate>
	
		<div id="swimmanager-errors" class="alert alert-danger alert-dismissable col-12" role="alert" style="background: #f2dede; color: #a94442; border-color: #ebccd1; text-align: left; display: none; border-radius: 3px; padding: 10px; margin-bottom: 10px;"></div>

		<div id="swimmanager-success" class="alert alert-success alert-dismissable col-12" role="alert"  style="background: #dff0d8; color: #3c763d; border-color: #d6e9c6; text-align: left; display: none; border-radius: 3px; padding: 10px; margin-bottom: 10px;"></div>

		<div class="row">
			<h3 class="col">Your Contact Details</h3>
		</div>
		
		<div class="row">
			<div class="col-12 col-sm-6">
				<base-input name="first_name" label="First Name" v-model.trim="$v.contact.first_name.$model" :validator="$v.contact.first_name" />
			</div>
			<div class="col-12 col-sm-6">
				<base-input name="last_name" label="Last Name" v-model.trim="$v.contact.last_name.$model" :validator="$v.contact.last_name" />
			</div>
			<div class="col-12 col-md-6">
				<base-input value="a" name="email" label="Email" v-model.trim="$v.contact.email.$model" :validator="$v.contact.email" />
			</div>
			<div class="col-12 col-md-6">
				<base-input value="a" name="phone" label="Mobile Phone" v-model.trim="$v.contact.phone.$model" :validator="$v.contact.phone" />
			</div>
		</div>
		
		<div v-if="widgetConfig.enableContactIsSwimmer">
			<div class="row">
				<div>
					<base-checkbox id="contact_is_swimmer" :true-value="true" :false-value="false" option="" name="contact_is_swimmer" label="I am a registered member or swimmer" v-model="contact_is_swimmer" />
				</div>
			</div>
		</div>
			
		<div v-if="contact_is_swimmer">
				<div class="row">
					<div class="col-12 col-sm-6">
						<div class="mb-3">
							<base-input name="date_of_birth" label="Date of Birth" v-model="$v.contact.date_of_birth.$model" :validator="$v.contact.date_of_birth" type="date" />
						</div>
					</div>
					<div class="col-12 col-sm-6">
						<div class="mb-3">
							<base-select v-model="$v.contact.gender.$model" :validator="$v.contact.gender" :options="genderOptions" name="gender" label="Gender" />
						</div>
					</div>
					<div class="col-12 col-sm-6">
						<div class="mb-3">
							<base-input value="a" v-model="$v.contact.asa_number.$model" :validator="$v.contact.asa_number" name="asa_number" label="Membership Number" />
						</div>
					</div>
					<div class="col-12 col-sm-6">
						<div class="mb-3">
							<base-input v-model="$v.contact.current_club.$model" :validator="$v.contact.current_club" name="current_club" label="Current Club" />
						</div>
					</div>
				</div>
		</div>

			<div v-if="widgetConfig.enableOnBehalfOf">
				<div class="row">
					<base-checkbox @input="setupMembers" id="on_behalf_of" :true-value="true" :false-value="false" option="" name="on_behalf_of" label="I am enquiring on behalf of a family member or child" v-model="on_behalf_of" />
				</div>
			</div>


		<div v-if="on_behalf_of">
			<div v-for="(member, memberIdx) in $v.members.$each.$iter">
	
				<div class="row">
					<h3 class="col">Swimmer Details
						<div class="btn btn-danger btn-sm" v-on:click="removeMember(memberIdx)">
							Remove
						</div>
					</h3>
				</div>
		
				<div class="row">
					<div class="col-12 col-sm-6 col-md-4">
						<base-input value="a" name="first_name" label="First Name" v-model.trim="member.first_name.$model" :validator="member.first_name" />
					</div>
					<div class="col-12 col-sm-6 col-md-4">
						<base-input value="a" name="last_name" label="Last Name" v-model.trim="member.last_name.$model" :validator="member.last_name"/>
					</div>
					<div class="col-12 col-sm-6 col-md-4">
						<base-input value="a" name="date_of_birth" label="Date of Birth" v-model="member.date_of_birth.$model" :validator="member.date_of_birth" type="date" />
					</div>
					<div class="col-12 col-sm-6 col-md-4">
						<base-select v-model.trim="member.gender.$model" :validator="member.gender" :options="genderOptions" name="gender" label="Gender" />
					</div>
					<div class="col-12 col-sm-6 col-md-4">
						<base-input v-model.trim="member.asa_number.$model" :validator="member.asa_number" name="asa_number" label="Membership Number" />
					</div>
					<div class="col-12 col-sm-6 col-md-4">
						<base-input v-model.trim="member.current_club.$model" :validator="member.current_club" name="current_club" label="Current Club" />
					</div>
				</div>
				
			</div>
	
			<div class="row">
				<div class="col-12 col-md-3">
					<div class="btn btn-primary mb-3" v-on:click="addMember">
						Add Another Swimmer
					</div>
				</div>			
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-md-12">
				<div class="mb-3">
					<base-text-area name="message" label="Enquiry Details" :height="200" v-model="$v.message.$model" :validator="$v.message" />
				</div>
			</div>
		</div>
		</form>
	</div>
</template>
<script>
import { Message, Loading } from 'element-ui';
import BaseInput from "../forms/BaseInput.vue";
import BaseSelect from "../forms/BaseSelect.vue";
import BaseRadioButtonGroup from "../forms/BaseRadioButtonGroup.vue";
import BaseCheckbox from "../forms/BaseCheckbox.vue";
import BaseTextArea from "../forms/BaseTextArea.vue";
import dayjs from "dayjs";
import { required, email, alpha, alphaNum, numeric, requiredIf } from 'vuelidate/lib/validators';
export default {
	components: {BaseTextArea, BaseCheckbox, BaseRadioButtonGroup, BaseSelect, BaseInput, Message},
	props: {
		baseUrl: {
			type: String,
			required: true,
		},
		config: {
			type: Object,
			required: false,
			default: {},
		}
	},
	data: function() {
		return {
			members: [

			],
			contact: {
				first_name: null,
				last_name: null,
				email: null,
				phone: null,
				gender: null,
				date_of_birth: '',
				asa_number: '',
				current_club: '',
			},
			contact_is_swimmer: false,
			on_behalf_of: false,
			enquiryPostUrl: '/website/enquiry',
			message: '',
			widgetConfig: {
				formHeading: 'Enquiry Details',
				enableOnBehalfOf: true,
				onBehalfOf: false,
				enableContactIsSwimmer: true,
				contactIsSwimmer: false,
				successRedirect: null
			},
			errors: {},
			saving: false,
			loading: null,
			genderOptions: [
				{
					value: null,
					label: '-- Please Select --'
				},
				{
					value: 'Female',
					label: 'Female'
				},
				{
					value: 'Male',
					label: 'Male'
				},
			],
		}
	},
	computed: {
	},
	created() {
		console.log('Enquiry form created')
		Object.assign(this.widgetConfig, this.config)
		this.contact_is_swimmer = this.widgetConfig.contactIsSwimmer
		this.on_behalf_of = this.widgetConfig.onBehalfOf
	},
	mounted() {
		console.log('Enquiry Form mounted.');
	},
	validations: {
		message: {
			required,
		},
		contact: {
			first_name: { required, alpha },
			last_name: { required, alpha },
			email: { required, email },
			phone: { required, numeric },
			date_of_birth: { 
				validDate(value) {
					return (value === '' && !this.contact_is_swimmer) || dayjs(value, 'YYYY-MM-DD').isValid()
				}
			},
			gender: {
				alpha 
			},
			asa_number: { alphaNum },
			current_club: { alpha }
		},
		members: {
			$each : {
				first_name: { required, alpha },
				last_name: { required, alpha },
				gender: { required, alpha },
				date_of_birth: { 
					required,
					validDate(value) {
						return dayjs(value, 'YYYY-MM-DD').isValid()
					}
				},
				asa_number: { alphaNum },
				current_club: { alpha }
			}
		},
	},
	methods: {
		addMember() {
			this.members.push({
				first_name: '',
				last_name: '',
				gender: '',
				date_of_birth: '',
				asa_number: '',
				current_club: ''
			});
		},
		removeMember(memberIdx) {
			this.members.splice(memberIdx, 1)
		},
		onSubmit() {
			if (this.saving === true) {
				console.log('double-click');
				return;
			}
			this.$v.$touch();
			if (!this.$v.$invalid) return;
			const requestBody = {
				contact: this.contact,
				members: this.on_behalf_of ? 
					this.members.filter((member) => {
						return member.first_name.length > 0 
							&& member.last_name.length > 0
					})
					: [],
				message: this.message
			}
			console.log('posting...', requestBody)
			this.saving = true;
			this.loading = this.$loading({
				target: '#enquiry-form-widget'
			});

			axios.post(`${this.baseUrl}${this.enquiryPostUrl}`, requestBody).then(response => {
				console.log('Enquiry has been posted', response);
				this.resetForm();
				this.$message({message: response.data.message, type: 'success'});
				window.location.href=this.widgetConfig.successRedirect;
			}).catch(err => {
				console.log('An error occurred', err);
			})
			.finally(() => {
				this.saving = false;
				this.loading.close();
			});

		},
		resetForm() {
			this.members = []
		},
		prepareData() {
			return this.members.push(contact);
		},
		debug(message) {
			console.log('NewInvoice: ' + message);
		},
		setupMembers(value) {
			console.log('setup members', [value])
			if (value === true) {
				if (this.members.length == 0) {
					this.addMember();
				}
			}
			if (value === false) {
				this.members = [];
			}
		}
	}
}
</script>